module.exports = __webpack_public_path__ + "08_long_black.2a59e9f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/08_long_black.png
// module id = Jo1J
// module chunks = 0